import { render } from "./InboxList.vue?vue&type=template&id=5da39ea5&scoped=true"
import script from "./InboxList.vue?vue&type=script&lang=js"
export * from "./InboxList.vue?vue&type=script&lang=js"

import "./InboxList.vue?vue&type=style&index=0&id=5da39ea5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da39ea5"]])

export default __exports__